import React, { useEffect, useState } from "react";
import brandImg1 from "../../assets/images/brand1.jpg";
import { FaTiktok, FaYoutube, FaFacebook, FaTelegram } from "react-icons/fa";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { api } from "../../services/api/api.index";
import { API_URL } from "../../services/api/config";
import Toggle from "./Toggle";
import { Modal } from "antd";

const Main = ({ children }) => {
  const [openToggle, setOpenToggle] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [itemsBlog, setItemsBlog] = useState([]);
  const [anotherLink, setAnotherLink] = useState(false);
  const [loading, setLoading] = useState(false);
  let path = useLocation();
  const navigate = useNavigate();

  const getDataBlogs = async () => {
    setLoading(true);
    try {
      let { data, metadata } = await api.get(
        `${API_URL}api/v1/blogs/external`,
        {
          depth: 2,
        }
      );
      setItemsBlog(data);
    } catch (e) {
      setLoading(false);
    }
  };
  const clickGolden = async (check) => {
    if (check) {
      navigate("/");
      setAnotherLink(true);
    } else {
      document?.getElementById("bookGolden")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  useEffect(() => {
    getDataBlogs();
  }, []);
  useEffect(() => {
    if (!localStorage?.getItem("FIRST_TIME")) {
      setTimeout(setOpenPopup(true), 500);
      localStorage.setItem("FIRST_TIME", true);
    }
  }, []);
  useEffect(() => {
    if (anotherLink) {
      document?.getElementById("bookGolden")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      setAnotherLink(false);
    }
  }, [anotherLink]);

  useEffect(() => {
    if (!anotherLink) {
      window.scrollTo(0, 0);
    }
  }, [path?.pathname]);

  const getOpen = () => {
    setOpenToggle(!openToggle);
  };
  return (
    <div className="container">
      <Modal
        open={openPopup}
        title={null}
        onCancel={(e) => {
          setOpenPopup(false);
        }}
        closable={false}
        footer={null}
        centered
      >
        <p
          style={{
            width: "100%",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "bold",
            margin: "0 ",
          }}
        >
          ⚠️ Miễn Trừ Trách Nhiệm
        </p>{" "}
        <br />
        &nbsp;&nbsp;Tất cả nội dung trên website này chỉ nhằm mục đích cung cấp
        thông tin và kiến thức, không phải là lời khuyên đầu tư hoặc cam kết lợi
        nhuận.
        <br /> <br /> &nbsp;&nbsp;Tại Việt Nam, giao dịch Forex và các công cụ
        tài chính phái sinh (CFD) tiềm ẩn rủi ro cao, bao gồm cả rủi ro pháp lý.
        Người dùng nên tìm hiểu kỹ các quy định pháp luật hiện hành và cân nhắc
        cẩn thận trước khi tham gia giao dịch. <br /> <br /> &nbsp;&nbsp;👉 Bằng
        việc tiếp tục truy cập website, bạn đồng ý với các điều khoản và điều
        kiện sử dụng của chúng tôi.
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "16px",
          }}
        >
          <div
            style={{
              fontSize: "16px",
              borderRadius: "4px",
              cursor: "pointer",
              background: "rgb(237,23,23)",
              color: "#fff",
              width: "120px",
              textAlign: "center",
              padding: "4px 0",
            }}
            onClick={() => setOpenPopup(false)}
          >
            ĐỒNG Ý
          </div>
        </div>
      </Modal>
      <div className="homepage__navbar--mobile">
        <div className="homepage__navbar--mobile__left">
          <Link
            to={`/`}
            style={{ textDecoration: "none", color: "#fff" }}
            onClick={() => path?.pathname === "/" && window.scrollTo(0, 0)}
          >
            <img src={brandImg1} />
          </Link>
        </div>
        <Toggle open={openToggle} getOpen={() => getOpen()} />
      </div>
      <div
        className={
          !openToggle
            ? "homepage__navbar--mobile__menu--open"
            : "homepage__navbar--mobile__menu--close"
        }
      >
        <div
          className="homepage__navbar--mobile__link"
          onClick={() => setOpenToggle(!openToggle)}
        >
          <Link
            to={`/`}
            onClick={() => {
              path?.pathname === "/" && window.scrollTo(0, 0);
            }}
          >
            Trang chủ
          </Link>
        </div>

        <div className="homepage__navbar--mobile__link">
          <Link
            to={`/blogs/${
              itemsBlog.find((x) => x.slug === "gioi-thieu")?.url_path
            }`}
            onClick={() => setOpenToggle(!openToggle)}
          >
            Giới thiệu
          </Link>
        </div>
        <div className="homepage__navbar--mobile__link">
          <Link to={`/event`} onClick={() => setOpenToggle(!openToggle)}>
            Các chương trình đang diễn ra
          </Link>
        </div>
        <div className="homepage__navbar--mobile__link">
          <Link
            to={`/blogs/${itemsBlog[1]?.url_path}`}
            onClick={() => setOpenToggle(!openToggle)}
          >
            Dành cho người mới
          </Link>
        </div>
        <div className="homepage__navbar--mobile__link">
          <Link to={`/blogs`} onClick={() => setOpenToggle(!openToggle)}>
            Blog
          </Link>
        </div>
        <div className="homepage__navbar--mobile__link">
          <a href={`https://one.exnessonelink.com/a/t1k4u1k4`} target="_blank">
            Đăng kí tài khoản Exness
          </a>
        </div>
        <div className="homepage__navbar--mobile__link">
          <div
            onClick={() => {
              path?.pathname === "/" ? clickGolden(false) : clickGolden(true);
              setOpenToggle(!openToggle);
            }}
          >
            Sổ vàng lãi kép
          </div>
        </div>
      </div>
      <div className="homepage__navbar">
        <div
          style={{
            margin: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "left",
            width: "1200px",
          }}
        >
          <div className="homepage__navbar__left">
            <Link
              to={`/`}
              style={{ textDecoration: "none", color: "#fff" }}
              onClick={() => path?.pathname === "/" && window.scrollTo(0, 0)}
            >
              <img src={brandImg1} />
            </Link>
          </div>
          <div className="homepage__navbar__right">
            <Link
              to={`/`}
              className="homepage__navbar__right__child box"
              onClick={() => {
                path?.pathname === "/" && window.scrollTo(0, 0);
              }}
            >
              <div className="glass"></div>
              <div>Trang chủ</div>
            </Link>

            <Link
              to={`/blogs/${
                itemsBlog.find((x) => x.slug === "gioi-thieu")?.url_path
              }`}
              className="homepage__navbar__right__child box"
            >
              <div className="glass"></div>
              <div>Giới thiệu</div>
            </Link>
            <Link to={`/event`} className="homepage__navbar__right__child box">
              <div className="glass"></div>
              Các chương trình đang diễn ra
              {/* <div className="homepage__navbar__right__child__items">
                <div
                  style={{
                    width: "100%",
                    background: "#fff",
                    borderRadius: "0 0 4px 4px",
                  }}
                >
                  {itemsForm.map((x, index) => (
                    <Link to={`/form?utm_source=${x.utm_source}`} key={index}>
                      {x.short_name}
                    </Link>
                  ))}
                </div>
              </div> */}
            </Link>
            <Link
              to={`/blogs/${
                itemsBlog.find((x) => x.slug === "danh-cho-nguoi-moi")?.url_path
              }`}
              className="homepage__navbar__right__child box"
            >
              <div className="glass"></div>
              <div>Dành cho người mới</div>
            </Link>
            <Link to={`/blogs`} className="homepage__navbar__right__child box">
              <div className="glass"></div>
              Blog
            </Link>
            <a
              href={`https://one.exnessonelink.com/a/t1k4u1k4`}
              className="homepage__navbar__right__child box"
              target="_blank"
            >
              <div className="glass"></div>
              Đăng kí tài khoản Exness
            </a>
            <div
              className="homepage__navbar__right__child box"
              onClick={() =>
                path?.pathname === "/" ? clickGolden(false) : clickGolden(true)
              }
            >
              <div className="glass"></div>
              Sổ vàng lãi kép
            </div>
          </div>
        </div>
      </div>
      <div className="homepage">
        <div
          className={`children-page ${
            open ? "children-page--open" : "children-page--close"
          }`}
        >
          <Outlet />
        </div>
      </div>
      <div className="homepage__footer">
        <div
          style={{
            margin: "auto",
            display: "flex",
            alignItems: "top",
            justifyContent: "space-between",
            width: "1200px",
          }}
        >
          <div className="homepage__footer__description">
            <h4>CỘNG ĐỒNG DNI INVEST</h4>
            <div className="homepage__footer__link">
              <a href="https://t.me/dniinvest" target="_blank">
                <FaTelegram />
                &nbsp; Channel DNI Invest
              </a>
              <a href="https://t.me/cryptodni56" target="_blank">
                <FaTelegram />
                &nbsp; DNI Crypto
              </a>
            </div>
          </div>
          <div className="homepage__footer__description">
            <h4>Kết nối với chúng tôi </h4>
            <div className="homepage__footer__link">
              <a href="https://www.facebook.com/dni.invest" target="_blank">
                <FaFacebook />
                &nbsp; Facebook
              </a>
              <a href="https://www.youtube.com/@DoanNamInvest" target="_blank">
                <FaYoutube />
                &nbsp; Youtube
              </a>
              <a href="https://www.tiktok.com/@namdoan.dni" target="_blank">
                <FaTiktok />
                &nbsp; Tiktok
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
